import { render } from "./DataAttribut.vue?vue&type=template&id=6e6ddc38"
import script from "./DataAttribut.vue?vue&type=script&lang=js"
export * from "./DataAttribut.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/e/med/Project/primitive/whouse-disperindag/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__